export default __webpack_public_path__ + "static/media/poki@3x.04986dd7.png";